export default value => (value || '').toString()
  .match(/^(http[s]?:\/\/(www\.)?){1}tiktok.com\/@[^/\s]+\/?$/g)
